// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.AuthMeds {\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  line-height: 65px;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.AuthsBtn {\n  margin: 100px auto;\n  width: 324px;\n  padding: 9px 3.5rem;\n  line-height: 65px;\n}\n.timer-container {\n  position: absolute;\n  right: 30px;\n  top: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
